define('SageDotCom/DataLayer/Events/secondary-nav-interaction',[
    "SageDotCom/DataLayer/Events/eventBase"
], function (EventBase) {

    function SecondaryNavInteractionEvent(el) {
        EventBase.call(this);
        
        this.props = {
            "event_name": "secondary_nav_int",
            "event_non-int ": "0",
            "event_category": "component",
            "event_action": "secondary_nav",
            "event_label": el.innerText,
            "event_name_level_1": this.getId(el),
            "event_name_level_2": el.href,
            "event_name_level_3": "",
            "event_name_level_4": ""
        };
    }

    SecondaryNavInteractionEvent.prototype = Object.create(EventBase.prototype);

    return SecondaryNavInteractionEvent;
});
